var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment",attrs:{"id":"comment-container"}},[_c('f-comment-header'),_vm._v(" "),_c('f-comment-content'),_vm._v(" "),_c('f-comment-footer',{attrs:{"proposalEncryptId":_vm.proposal_id,"isProposal":_vm.isProposal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }